import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { EditOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import Header from "../../components/Header/Header";
import Menu from "../../components/Menu/Menu";
import { productsService } from "../../services/ProductsService";
import "./Product.scss";
import { Link } from 'react-router-dom';

const Product = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);

    useEffect(() => {
        productsService.getProduct(id).then(res => {
            setProduct(res.data);
        });
    }, [id]);

    if (!product) return null;
    console.log('PRODUCT:', product);

    return (
        <div className="standard products product-details">
            <Header />

            <div className="standard__container">
                <Menu />

                <div className="standard__wrapper">
                    <div className="product-details__wrapper">


                        <h2 className='standard__page-title'>Detalii produs</h2>
                        <h4 className='standard__page-info'>
                            Această pagină îți permite să vizualizezi și să editezi detaliile produsului.
                        </h4>

                        <Link to='/liste-in-ofertare' className='standard__link'>
                            <div className='biding__back'>
                                <img src="/images/back.png" />
                                <h4>Înapoi</h4>
                            </div>
                        </Link>

                        <ProductSection title="Detalii de bază">
                            <div className="product-grid">
                                <div className="product-table">
                                    <Info label="Nume produs" value={product.name} />
                                    <Info label="Cod de bare" value={product.barcode} />
                                    <Info label="Preț vânzare" value={`${product.selling_price} RON`} />
                                    <Info label="Preț achiziție" value={`${product.purchase_price} RON`} />
                                    <Info label="Unitate de măsură" value={product.measurement_unit} />
                                    <Info label="TVA" value={`${product.tva}%`} />
                                    <Info label="Adaos comercial" value={`${product.markup}%`} />
                                </div>

                                <div className="product-image">
                                    <div className="upload-box">+</div>
                                </div>
                            </div>
                        </ProductSection>

                        <ProductSection title="Categorizare">
                            <div className="product-table">
                                <Info label="Clasă" value={product.class_name} />
                                <Info label="Grupă" value={product.group_name} />
                                <Info label="Sub-grupă" value={product.subgroup_name || "-"} />
                            </div>
                        </ProductSection>

                        <ProductSection title="Gestiune stocuri">
                            <div className="product-table">
                                <Info label="Stoc" value={product.stock} />
                                <Info label="Stoc minim" value={product.min_stock} />
                            </div>
                        </ProductSection>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ProductSection = ({ title, children }) => (
    <div className="product-section">
        <div className="product-section__header">
            <h3>{title}</h3>
            <Button type="link" icon={<EditOutlined />}>
                Editează detalii
            </Button>
        </div>

        <div className="product-section__content">
            {children}
        </div>
    </div>
);

const Info = ({ label, value }) => (
    <div className="info-row">
        <span>{label}</span>
        <strong>{value}</strong>
    </div>
);

export default Product;